import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { OA_DOCUMENT_FILE_KEY, OA_ROUTE_ACTIONS, OA_ROUTE_PARAM_KEYS } from "../../oa-query-schema";
import { updateSearchParams } from "@/utils/urlFilterParams";

export default function useOARouteActions() {
	const location = useLocation();
	const navigate = useNavigate();

	const replaceSearch = useCallback(
		(changes) => {
			const nextSearch = updateSearchParams(location.search, changes);
			navigate(
				{
					pathname: location.pathname,
					search: nextSearch ? `?${nextSearch}` : "",
					hash: location.hash,
				},
				{ replace: true },
			);
		},
		[location.hash, location.pathname, location.search, navigate],
	);

	const openOrderActionModal = useCallback(
		(action, applicationOrderId) => {
			if (!applicationOrderId) {
				return;
			}

			replaceSearch({
				[OA_ROUTE_PARAM_KEYS.oa]: applicationOrderId,
				[OA_ROUTE_PARAM_KEYS.action]: action,
			});
		},
		[replaceSearch],
	);

	const openPreview = useCallback(
		(applicationOrderId) => {
			openOrderActionModal(OA_ROUTE_ACTIONS.preview, applicationOrderId);
		},
		[openOrderActionModal],
	);

	const openNotice = useCallback(
		(applicationOrderId) => {
			openOrderActionModal(OA_ROUTE_ACTIONS.notice, applicationOrderId);
		},
		[openOrderActionModal],
	);

	const openDocuments = useCallback(
		(applicationOrderId) => {
			if (!applicationOrderId) {
				return;
			}

			replaceSearch({
				[OA_ROUTE_PARAM_KEYS.file]: OA_DOCUMENT_FILE_KEY,
				[OA_ROUTE_PARAM_KEYS.code]: applicationOrderId,
			});
		},
		[replaceSearch],
	);

	return {
		openOrderActionModal,
		openPreview,
		openNotice,
		openDocuments,
	};
}
